export default __webpack_public_path__ + "media/images/bar-hire-70719aec121c20d1a68f96f56411a0a3.png";